/**
 * @flow
 * @relayHash a0e5768928327bf3b76c7ccf2e774502
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AccountType = "FISA" | "GIACorporate" | "GIAIndividual" | "GIAJoint" | "GIATrust" | "JISA" | "SIPP" | "%future added value";
export type ActionType = "AA" | "AACK" | "AAD" | "ABF" | "AC" | "ACCL" | "ACH" | "ACR" | "ACRO" | "ADIE" | "AEC" | "AEIE" | "AFDA" | "AFDR" | "AFDU" | "AFNC" | "AFNU" | "AIAD" | "AIAE" | "AIAN" | "AIAR" | "AIAS" | "AIAT" | "AIRR" | "AIRS" | "AIRT" | "AM" | "ANC" | "AR" | "ARE" | "AS" | "ATCH" | "AU" | "BAAD" | "BACR" | "BADI" | "BAIG" | "BAPE" | "BAPI" | "BAPR" | "BAUI" | "BAUP" | "BAVE" | "BCC" | "BCU" | "BTIG" | "BTUI" | "CAREMFT" | "CASC" | "CASETFT" | "CASU" | "CIC" | "CISC" | "CISS" | "CISU" | "CIT" | "CIU" | "CIX" | "CTAPR" | "CTBLK" | "CTCAA" | "CTCAN" | "CTREC" | "CTREQ" | "CTUBL" | "CTVFY" | "EEU" | "FIFSI" | "FIFSP" | "FOTU" | "FSFSI" | "FSFSP" | "GCBFV" | "GCBRA" | "GCBRC" | "GCBRD" | "GCBRF" | "GCBRI" | "GCBRO" | "GCBRV" | "GCMAC" | "GCMBD" | "GCMCA" | "GCMCD" | "GCMCR" | "GCMEX" | "GCMFL" | "GCMGA" | "GCMRE" | "GCMRI" | "GCMRR" | "GCMRS" | "GCMSA" | "GCMSU" | "GCMTR" | "GCPCO" | "GCPCR" | "GCPFL" | "GCPPO" | "GCPSU" | "GCSAM" | "GCSCA" | "GCSCR" | "GCSDA" | "GCSFD" | "GCSFI" | "GCSPA" | "GCSPC" | "GCSPD" | "GCSPR" | "GCSRE" | "GCSSP" | "GCSSR" | "LLEDN" | "MACC" | "MATC" | "MATU" | "MLBAI" | "MLBAU" | "MLTC" | "MLTU" | "OAA" | "OAR" | "OC" | "OCC" | "OCD" | "OM" | "OMCLA" | "OMCLD" | "OMCLN" | "OMCLR" | "OMCNI" | "OMD" | "OMEXP" | "OMOVA" | "OMOVD" | "OMPR" | "OMQA" | "OMRBC" | "OP" | "OPCA" | "OPFC" | "OQ" | "OR" | "ORRCE" | "OTC" | "OX" | "RLWHCH" | "SC" | "SCR" | "SF" | "SR" | "SRA" | "SRF" | "SS" | "SU" | "TBF" | "TCH" | "TCR" | "TFDA" | "TFDR" | "TFDU" | "TIGC" | "TIGD" | "TIGU" | "TISC" | "TISU" | "TPC" | "TPU" | "TRSC" | "TRSU" | "ULMVF" | "ULMVS" | "ULNS" | "ULSC" | "ULUV" | "UMA" | "UMAF" | "UMAP" | "UMAR" | "UMARP" | "UMCP" | "UMCR" | "UMD" | "UMRRC" | "UMUD" | "UMURP" | "UUE" | "UUF" | "UUL" | "UUP" | "UUSA" | "UUSD" | "UUU" | "UVE" | "VSPA" | "VSPR" | "VSPU" | "WHCH" | "ZBTR" | "ZBTU" | "ZIR" | "ZITR" | "ZIU" | "ZPC" | "ZTP" | "ZTR" | "ZUC" | "ZUU" | "%future added value";
export type AdvancedOrderType = "BRA" | "NON" | "OCA" | "%future added value";
export type AmendStatus = "APL" | "FAI" | "LOG" | "REQ" | "%future added value";
export type Currency = "AUD" | "BGN" | "CAD" | "CHF" | "CLP" | "CNH" | "CNY" | "CZK" | "DKK" | "EUR" | "GBP" | "HKD" | "HUF" | "ISK" | "JPY" | "MXN" | "NOK" | "NZD" | "PLN" | "ROL" | "RON" | "RUB" | "SEK" | "SGD" | "USD" | "ZAR" | "%future added value";
export type FeeType = "ADE" | "ADF" | "ASB" | "AVH" | "BUF" | "CHI" | "CHIP" | "CHUP" | "CON" | "COR" | "CRDT" | "FXB" | "GST" | "INT" | "MGN" | "MSB" | "PLF" | "PLT" | "PRO" | "RTA" | "RTP" | "SIPP" | "STB" | "STBV" | "TAX" | "TRA" | "VHF" | "WDR" | "%future added value";
export type InstrumentType = "CASH" | "FUN" | "STK" | "WAR" | "%future added value";
export type OrderAlgo = "TWAP" | "VWAP" | "%future added value";
export type OrderApprovalStatus = "CA" | "CD" | "EX" | "IN" | "OA" | "OD" | "RR" | "SA" | "SFA" | "%future added value";
export type OrderProposalType = "BT" | "IN" | "PR" | "%future added value";
export type OrderStatus = "CAN" | "CRE" | "FIL" | "INI" | "INM" | "PEX" | "PFL" | "POS" | "QUE" | "REJ" | "%future added value";
export type OrderType = "LMT" | "MKT" | "SLMT" | "SMKT" | "TLMT" | "TMKT" | "%future added value";
export type PortfolioOrderStatus = "CAN" | "COM" | "CRE" | "FIL" | "PEX" | "PFL" | "PRO" | "REJ" | "%future added value";
export type ReportState = "ERR" | "FIN" | "REQ" | "%future added value";
export type StockOrderViewQueryVariables = {|
  stockOrderId?: ?string
|};
export type StockOrderViewQueryResponse = {|
  +viewer: ?{|
    +stockOrders: ?{|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +parentOrder: ?{|
            +id: string
          |},
          +id: string,
          +orderRef: ?string,
          +status: ?string,
          +pendingStatus: ?string,
          +price: ?number,
          +quantity: ?number,
          +cashQuantity: ?number,
          +side: ?string,
          +createdAt: any,
          +updatedAt: any,
          +orderType: OrderType,
          +quantityToDate: ?number,
          +executedQuantityToDate: ?number,
          +matched: ?boolean,
          +blockedHoldings: ?number,
          +blockedProceeds: ?number,
          +blockedBaseCharges: ?number,
          +blockedLocalCharges: ?number,
          +customCommission: ?number,
          +advancedOrderType: AdvancedOrderType,
          +actionLogs: ?{|
            +edges: $ReadOnlyArray<?{|
              +node: ?{|
                +actionId: number,
                +actionType: ActionType,
                +actionTime: any,
                +actionDescription: string,
                +user: ?{|
                  +fullName: ?string
                |},
              |}
            |}>
          |},
          +contract: {|
            +id: string,
            +currency: Currency,
            +symbol: string,
            +name: ?string,
            +industry: ?string,
            +ibConId: any,
            +instrumentType: InstrumentType,
            +exchange: {|
              +name: string,
              +symbol: string,
            |},
          |},
          +account: ?{|
            +id: string,
            +name: ?string,
            +clientaccount: ?{|
              +id: string,
              +accountType: ?AccountType,
            |},
          |},
          +portfolioOrder: {|
            +id: string
          |},
          +executionSet: ?{|
            +edges: $ReadOnlyArray<?{|
              +node: ?{|
                +transaction: ?{|
                  +id: string
                |},
                +price: number,
                +proceeds: ?number,
                +executionDatetime: any,
                +quantity: number,
                +currency: Currency,
              |}
            |}>
          |},
          +proceedsToDate: ?number,
          +proceedsToDateBase: ?number,
          +brokerOrder: ?{|
            +id: string,
            +twsOrderId: ?number,
            +twsPermId: ?number,
            +cashQuantity: ?number,
            +quantityFilled: ?number,
            +quantityLeft: ?number,
            +stopPrice: ?number,
            +trailStopRatio: ?number,
            +trailStopOffset: ?number,
            +lastSyncTime: ?any,
            +status: OrderStatus,
            +orderRef: ?string,
            +ackedClientOrderId: ?string,
            +brokerSideOrderId: ?string,
            +ibExchange: ?{|
              +id: string,
              +symbol: string,
            |},
            +algoParams: ?{|
              +algo: OrderAlgo,
              +orderalgoparamstwap: ?{|
                +strategyType: string,
                +startTime: ?any,
                +endTime: ?any,
                +allowPastEndTime: boolean,
              |},
              +orderalgoparamsvwap: ?{|
                +id: string,
                +maxVolumeRatio: ?number,
                +startTime: ?any,
                +endTime: ?any,
                +allowPastEndTime: boolean,
                +neverTakeLiquidity: boolean,
                +speedup: ?boolean,
              |},
            |},
            +brokerorderamendmentSet: {|
              +edges: $ReadOnlyArray<?{|
                +node: ?{|
                  +id: string,
                  +limitPrice: ?number,
                  +previousLimitPrice: ?number,
                  +quantity: number,
                  +previousQuantity: number,
                  +status: AmendStatus,
                  +blockingRevised: boolean,
                  +createdAt: any,
                  +updatedAt: any,
                |}
              |}>
            |},
          |},
          +orderPtr: {|
            +orderapprovalcontractSet: {|
              +edges: $ReadOnlyArray<?{|
                +node: ?{|
                  +id: string,
                  +approval: {|
                    +id: string,
                    +portfolioOrder: ?{|
                      +id: string,
                      +status: PortfolioOrderStatus,
                    |},
                    +createdAt: any,
                    +updatedAt: any,
                    +approvedAt: ?any,
                    +notifiedAt: ?any,
                    +remindedAt: ?any,
                    +proposal: {|
                      +id: string,
                      +type: OrderProposalType,
                    |},
                    +rationaleUrl: ?string,
                    +approvedBy: ?{|
                      +fullName: ?string
                    |},
                    +status: OrderApprovalStatus,
                    +portfolio: {|
                      +id: string,
                      +trackingVueName: ?string,
                      +account: {|
                        +name: ?string,
                        +id: string,
                      |},
                    |},
                    +actionLogs: ?{|
                      +edges: $ReadOnlyArray<?{|
                        +node: ?{|
                          +id: string,
                          +actionDescription: string,
                          +actionId: number,
                          +actionTime: any,
                          +actionType: ActionType,
                          +user: ?{|
                            +id: string,
                            +fullName: ?string,
                          |},
                        |}
                      |}>
                    |},
                  |},
                |}
              |}>
            |}
          |},
          +tradeInvoice: ?{|
            +id: string,
            +pdfUrl: ?string,
            +pdf: ?string,
            +state: ReportState,
            +createdAt: any,
            +updatedAt: any,
            +portfolioOrder: ?{|
              +id: string
            |},
          |},
          +transactions: ?{|
            +edges: $ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +commission: ?number,
                +tax: ?number,
                +transactionaccountchargeSet: {|
                  +edges: $ReadOnlyArray<?{|
                    +node: ?{|
                      +id: string,
                      +amount: number,
                      +currency: Currency,
                      +feeType: FeeType,
                      +accountchargePtr: {|
                        +accountchargetenantportionSet: {|
                          +edges: $ReadOnlyArray<?{|
                            +node: ?{|
                              +id: string,
                              +quantity: number,
                              +tenant: ?{|
                                +name: string,
                                +id: string,
                              |},
                            |}
                          |}>
                        |}
                      |},
                    |}
                  |}>
                |},
              |}
            |}>
          |},
        |}
      |}>
    |},
    +exchanges: ?{|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +symbol: string,
          +nextDaySession: ?{|
            +startTime: ?any,
            +endTime: ?any,
          |},
        |}
      |}>
    |},
  |}
|};
export type StockOrderViewQuery = {|
  variables: StockOrderViewQueryVariables,
  response: StockOrderViewQueryResponse,
|};
*/


/*
query StockOrderViewQuery(
  $stockOrderId: ID
) {
  viewer {
    stockOrders(id: $stockOrderId) {
      edges {
        node {
          parentOrder {
            id
          }
          id
          orderRef
          status
          pendingStatus
          price
          quantity
          cashQuantity
          side
          createdAt
          updatedAt
          orderType
          quantityToDate
          executedQuantityToDate
          matched
          blockedHoldings
          blockedProceeds
          blockedBaseCharges
          blockedLocalCharges
          customCommission
          advancedOrderType
          actionLogs(orderBy: "actionTime") {
            edges {
              node {
                actionId
                actionType
                actionTime
                actionDescription
                user {
                  fullName
                  id
                }
                id
              }
            }
          }
          contract {
            id
            currency
            symbol
            name
            industry
            ibConId
            instrumentType
            exchange {
              name
              symbol
              id
            }
          }
          account {
            id
            name
            clientaccount {
              id
              accountType
            }
          }
          portfolioOrder {
            id
          }
          executionSet {
            edges {
              node {
                transaction {
                  id
                }
                price
                proceeds
                executionDatetime
                quantity
                currency
                id
              }
            }
          }
          proceedsToDate
          proceedsToDateBase
          brokerOrder {
            id
            twsOrderId
            twsPermId
            cashQuantity
            quantityFilled
            quantityLeft
            stopPrice
            trailStopRatio
            trailStopOffset
            lastSyncTime
            status
            orderRef
            ackedClientOrderId
            brokerSideOrderId
            ibExchange {
              id
              symbol
            }
            algoParams {
              algo
              orderalgoparamstwap {
                strategyType
                startTime
                endTime
                allowPastEndTime
                id
              }
              orderalgoparamsvwap {
                id
                maxVolumeRatio
                startTime
                endTime
                allowPastEndTime
                neverTakeLiquidity
                speedup
              }
              id
            }
            brokerorderamendmentSet(orderBy: "sequence") {
              edges {
                node {
                  id
                  limitPrice
                  previousLimitPrice
                  quantity
                  previousQuantity
                  status
                  blockingRevised
                  createdAt
                  updatedAt
                }
              }
            }
          }
          orderPtr {
            orderapprovalcontractSet {
              edges {
                node {
                  id
                  approval {
                    id
                    portfolioOrder {
                      id
                      status
                    }
                    createdAt
                    updatedAt
                    approvedAt
                    notifiedAt
                    remindedAt
                    proposal {
                      id
                      type
                    }
                    rationaleUrl
                    approvedBy {
                      fullName
                      id
                    }
                    status
                    portfolio {
                      id
                      trackingVueName
                      account {
                        name
                        id
                      }
                    }
                    actionLogs {
                      edges {
                        node {
                          id
                          actionDescription
                          actionId
                          actionTime
                          actionType
                          user {
                            id
                            fullName
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            id
          }
          tradeInvoice {
            id
            pdfUrl
            pdf
            state
            createdAt
            updatedAt
            portfolioOrder {
              id
            }
          }
          transactions {
            edges {
              node {
                id
                commission
                tax
                transactionaccountchargeSet {
                  edges {
                    node {
                      id
                      amount
                      currency
                      feeType
                      accountchargePtr {
                        accountchargetenantportionSet {
                          edges {
                            node {
                              id
                              quantity
                              tenant {
                                name
                                id
                              }
                            }
                          }
                        }
                        id
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    exchanges {
      edges {
        node {
          symbol
          nextDaySession {
            startTime
            endTime
          }
          id
        }
      }
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "stockOrderId",
    "type": "ID",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "stockOrderId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
],
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "parentOrder",
  "storageKey": null,
  "args": null,
  "concreteType": "OrderNode",
  "plural": false,
  "selections": (v3/*: any*/)
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "orderRef",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pendingStatus",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "price",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cashQuantity",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "side",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "updatedAt",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "orderType",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantityToDate",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "executedQuantityToDate",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "matched",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "blockedHoldings",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "blockedProceeds",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "blockedBaseCharges",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "blockedLocalCharges",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "customCommission",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "advancedOrderType",
  "args": null,
  "storageKey": null
},
v24 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "actionTime"
  }
],
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "actionId",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "actionType",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "actionTime",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "actionDescription",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v30 = [
  (v29/*: any*/)
],
v31 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "symbol",
  "args": null,
  "storageKey": null
},
v33 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "industry",
  "args": null,
  "storageKey": null
},
v35 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ibConId",
  "args": null,
  "storageKey": null
},
v36 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "instrumentType",
  "args": null,
  "storageKey": null
},
v37 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "account",
  "storageKey": null,
  "args": null,
  "concreteType": "AccountNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v33/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "clientaccount",
      "storageKey": null,
      "args": null,
      "concreteType": "ClientAccountNode",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "accountType",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
},
v38 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "portfolioOrder",
  "storageKey": null,
  "args": null,
  "concreteType": "PortfolioOrderNode",
  "plural": false,
  "selections": (v3/*: any*/)
},
v39 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "transaction",
  "storageKey": null,
  "args": null,
  "concreteType": "TransactionNode",
  "plural": false,
  "selections": (v3/*: any*/)
},
v40 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "proceeds",
  "args": null,
  "storageKey": null
},
v41 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "executionDatetime",
  "args": null,
  "storageKey": null
},
v42 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "proceedsToDate",
  "args": null,
  "storageKey": null
},
v43 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "proceedsToDateBase",
  "args": null,
  "storageKey": null
},
v44 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "twsOrderId",
  "args": null,
  "storageKey": null
},
v45 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "twsPermId",
  "args": null,
  "storageKey": null
},
v46 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantityFilled",
  "args": null,
  "storageKey": null
},
v47 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantityLeft",
  "args": null,
  "storageKey": null
},
v48 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "stopPrice",
  "args": null,
  "storageKey": null
},
v49 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "trailStopRatio",
  "args": null,
  "storageKey": null
},
v50 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "trailStopOffset",
  "args": null,
  "storageKey": null
},
v51 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastSyncTime",
  "args": null,
  "storageKey": null
},
v52 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ackedClientOrderId",
  "args": null,
  "storageKey": null
},
v53 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "brokerSideOrderId",
  "args": null,
  "storageKey": null
},
v54 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "ibExchange",
  "storageKey": null,
  "args": null,
  "concreteType": "IBExchangeNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v32/*: any*/)
  ]
},
v55 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "algo",
  "args": null,
  "storageKey": null
},
v56 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "strategyType",
  "args": null,
  "storageKey": null
},
v57 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "startTime",
  "args": null,
  "storageKey": null
},
v58 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "endTime",
  "args": null,
  "storageKey": null
},
v59 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "allowPastEndTime",
  "args": null,
  "storageKey": null
},
v60 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "orderalgoparamsvwap",
  "storageKey": null,
  "args": null,
  "concreteType": "OrderAlgoParamsVWAPNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "maxVolumeRatio",
      "args": null,
      "storageKey": null
    },
    (v57/*: any*/),
    (v58/*: any*/),
    (v59/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "neverTakeLiquidity",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "speedup",
      "args": null,
      "storageKey": null
    }
  ]
},
v61 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "brokerorderamendmentSet",
  "storageKey": "brokerorderamendmentSet(orderBy:\"sequence\")",
  "args": [
    {
      "kind": "Literal",
      "name": "orderBy",
      "value": "sequence"
    }
  ],
  "concreteType": "BrokerOrderAmendmentNodeConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "BrokerOrderAmendmentNodeEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "BrokerOrderAmendmentNode",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "limitPrice",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "previousLimitPrice",
              "args": null,
              "storageKey": null
            },
            (v9/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "previousQuantity",
              "args": null,
              "storageKey": null
            },
            (v6/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "blockingRevised",
              "args": null,
              "storageKey": null
            },
            (v12/*: any*/),
            (v13/*: any*/)
          ]
        }
      ]
    }
  ]
},
v62 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "portfolioOrder",
  "storageKey": null,
  "args": null,
  "concreteType": "PortfolioOrderNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v6/*: any*/)
  ]
},
v63 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "approvedAt",
  "args": null,
  "storageKey": null
},
v64 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "notifiedAt",
  "args": null,
  "storageKey": null
},
v65 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "remindedAt",
  "args": null,
  "storageKey": null
},
v66 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "proposal",
  "storageKey": null,
  "args": null,
  "concreteType": "OrderProposalNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }
  ]
},
v67 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "rationaleUrl",
  "args": null,
  "storageKey": null
},
v68 = [
  (v33/*: any*/),
  (v2/*: any*/)
],
v69 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "portfolio",
  "storageKey": null,
  "args": null,
  "concreteType": "PortfolioNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "trackingVueName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "account",
      "storageKey": null,
      "args": null,
      "concreteType": "AccountNode",
      "plural": false,
      "selections": (v68/*: any*/)
    }
  ]
},
v70 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "actionLogs",
  "storageKey": null,
  "args": null,
  "concreteType": "ActionLogUserRequestNodeConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "ActionLogUserRequestNodeEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "ActionLogUserRequestNode",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v28/*: any*/),
            (v25/*: any*/),
            (v27/*: any*/),
            (v26/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "user",
              "storageKey": null,
              "args": null,
              "concreteType": "UserNode",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                (v29/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
},
v71 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "tradeInvoice",
  "storageKey": null,
  "args": null,
  "concreteType": "TradeInvoiceNode",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pdfUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pdf",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "state",
      "args": null,
      "storageKey": null
    },
    (v12/*: any*/),
    (v13/*: any*/),
    (v38/*: any*/)
  ]
},
v72 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "commission",
  "args": null,
  "storageKey": null
},
v73 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "tax",
  "args": null,
  "storageKey": null
},
v74 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v75 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "feeType",
  "args": null,
  "storageKey": null
},
v76 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "accountchargetenantportionSet",
  "storageKey": null,
  "args": null,
  "concreteType": "AccountChargeTenantPortionNodeConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "AccountChargeTenantPortionNodeEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "AccountChargeTenantPortionNode",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v9/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "tenant",
              "storageKey": null,
              "args": null,
              "concreteType": "TenantNode",
              "plural": false,
              "selections": (v68/*: any*/)
            }
          ]
        }
      ]
    }
  ]
},
v77 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "nextDaySession",
  "storageKey": null,
  "args": null,
  "concreteType": "ExchangeSessionType",
  "plural": false,
  "selections": [
    (v57/*: any*/),
    (v58/*: any*/)
  ]
},
v78 = [
  (v29/*: any*/),
  (v2/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "StockOrderViewQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "stockOrders",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "StockOrderNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "StockOrderNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StockOrderNode",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v2/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "actionLogs",
                        "storageKey": "actionLogs(orderBy:\"actionTime\")",
                        "args": (v24/*: any*/),
                        "concreteType": "ActionLogUserRequestNodeConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ActionLogUserRequestNodeEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ActionLogUserRequestNode",
                                "plural": false,
                                "selections": [
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UserNode",
                                    "plural": false,
                                    "selections": (v30/*: any*/)
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "contract",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ContractNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v36/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "exchange",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ExchangeNode",
                            "plural": false,
                            "selections": [
                              (v33/*: any*/),
                              (v32/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v37/*: any*/),
                      (v38/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "executionSet",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ExecutionNodeConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ExecutionNodeEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ExecutionNode",
                                "plural": false,
                                "selections": [
                                  (v39/*: any*/),
                                  (v8/*: any*/),
                                  (v40/*: any*/),
                                  (v41/*: any*/),
                                  (v9/*: any*/),
                                  (v31/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v42/*: any*/),
                      (v43/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "brokerOrder",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BrokerOrderNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v44/*: any*/),
                          (v45/*: any*/),
                          (v10/*: any*/),
                          (v46/*: any*/),
                          (v47/*: any*/),
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v6/*: any*/),
                          (v5/*: any*/),
                          (v52/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "algoParams",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "OrderAlgoParamsNode",
                            "plural": false,
                            "selections": [
                              (v55/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "orderalgoparamstwap",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "OrderAlgoParamsTWAPNode",
                                "plural": false,
                                "selections": [
                                  (v56/*: any*/),
                                  (v57/*: any*/),
                                  (v58/*: any*/),
                                  (v59/*: any*/)
                                ]
                              },
                              (v60/*: any*/)
                            ]
                          },
                          (v61/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "orderPtr",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "OrderNode",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "orderapprovalcontractSet",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "OrderApprovalContractNodeConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "OrderApprovalContractNodeEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "OrderApprovalContractNode",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "approval",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "OrderApprovalNode",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v62/*: any*/),
                                          (v12/*: any*/),
                                          (v13/*: any*/),
                                          (v63/*: any*/),
                                          (v64/*: any*/),
                                          (v65/*: any*/),
                                          (v66/*: any*/),
                                          (v67/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "approvedBy",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "UserNode",
                                            "plural": false,
                                            "selections": (v30/*: any*/)
                                          },
                                          (v6/*: any*/),
                                          (v69/*: any*/),
                                          (v70/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v71/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "transactions",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TransactionNodeConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TransactionNodeEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TransactionNode",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v72/*: any*/),
                                  (v73/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "transactionaccountchargeSet",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "TransactionAccountChargeNodeConnection",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "edges",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "TransactionAccountChargeNodeEdge",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "TransactionAccountChargeNode",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              (v74/*: any*/),
                                              (v31/*: any*/),
                                              (v75/*: any*/),
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "accountchargePtr",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "AccountChargeNode",
                                                "plural": false,
                                                "selections": [
                                                  (v76/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "exchanges",
            "storageKey": null,
            "args": null,
            "concreteType": "ExchangeNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ExchangeNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ExchangeNode",
                    "plural": false,
                    "selections": [
                      (v32/*: any*/),
                      (v77/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "StockOrderViewQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "stockOrders",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "StockOrderNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "StockOrderNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StockOrderNode",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v2/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "actionLogs",
                        "storageKey": "actionLogs(orderBy:\"actionTime\")",
                        "args": (v24/*: any*/),
                        "concreteType": "ActionLogUserRequestNodeConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ActionLogUserRequestNodeEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ActionLogUserRequestNode",
                                "plural": false,
                                "selections": [
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UserNode",
                                    "plural": false,
                                    "selections": (v78/*: any*/)
                                  },
                                  (v2/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "contract",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ContractNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v36/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "exchange",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ExchangeNode",
                            "plural": false,
                            "selections": [
                              (v33/*: any*/),
                              (v32/*: any*/),
                              (v2/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v37/*: any*/),
                      (v38/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "executionSet",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ExecutionNodeConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ExecutionNodeEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ExecutionNode",
                                "plural": false,
                                "selections": [
                                  (v39/*: any*/),
                                  (v8/*: any*/),
                                  (v40/*: any*/),
                                  (v41/*: any*/),
                                  (v9/*: any*/),
                                  (v31/*: any*/),
                                  (v2/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v42/*: any*/),
                      (v43/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "brokerOrder",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BrokerOrderNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v44/*: any*/),
                          (v45/*: any*/),
                          (v10/*: any*/),
                          (v46/*: any*/),
                          (v47/*: any*/),
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v6/*: any*/),
                          (v5/*: any*/),
                          (v52/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "algoParams",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "OrderAlgoParamsNode",
                            "plural": false,
                            "selections": [
                              (v55/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "orderalgoparamstwap",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "OrderAlgoParamsTWAPNode",
                                "plural": false,
                                "selections": [
                                  (v56/*: any*/),
                                  (v57/*: any*/),
                                  (v58/*: any*/),
                                  (v59/*: any*/),
                                  (v2/*: any*/)
                                ]
                              },
                              (v60/*: any*/),
                              (v2/*: any*/)
                            ]
                          },
                          (v61/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "orderPtr",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "OrderNode",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "orderapprovalcontractSet",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "OrderApprovalContractNodeConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "OrderApprovalContractNodeEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "OrderApprovalContractNode",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "approval",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "OrderApprovalNode",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v62/*: any*/),
                                          (v12/*: any*/),
                                          (v13/*: any*/),
                                          (v63/*: any*/),
                                          (v64/*: any*/),
                                          (v65/*: any*/),
                                          (v66/*: any*/),
                                          (v67/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "approvedBy",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "UserNode",
                                            "plural": false,
                                            "selections": (v78/*: any*/)
                                          },
                                          (v6/*: any*/),
                                          (v69/*: any*/),
                                          (v70/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v2/*: any*/)
                        ]
                      },
                      (v71/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "transactions",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TransactionNodeConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TransactionNodeEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TransactionNode",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v72/*: any*/),
                                  (v73/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "transactionaccountchargeSet",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "TransactionAccountChargeNodeConnection",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "edges",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "TransactionAccountChargeNodeEdge",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "TransactionAccountChargeNode",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              (v74/*: any*/),
                                              (v31/*: any*/),
                                              (v75/*: any*/),
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "accountchargePtr",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "AccountChargeNode",
                                                "plural": false,
                                                "selections": [
                                                  (v76/*: any*/),
                                                  (v2/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "exchanges",
            "storageKey": null,
            "args": null,
            "concreteType": "ExchangeNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ExchangeNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ExchangeNode",
                    "plural": false,
                    "selections": [
                      (v32/*: any*/),
                      (v77/*: any*/),
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "StockOrderViewQuery",
    "id": null,
    "text": "query StockOrderViewQuery(\n  $stockOrderId: ID\n) {\n  viewer {\n    stockOrders(id: $stockOrderId) {\n      edges {\n        node {\n          parentOrder {\n            id\n          }\n          id\n          orderRef\n          status\n          pendingStatus\n          price\n          quantity\n          cashQuantity\n          side\n          createdAt\n          updatedAt\n          orderType\n          quantityToDate\n          executedQuantityToDate\n          matched\n          blockedHoldings\n          blockedProceeds\n          blockedBaseCharges\n          blockedLocalCharges\n          customCommission\n          advancedOrderType\n          actionLogs(orderBy: \"actionTime\") {\n            edges {\n              node {\n                actionId\n                actionType\n                actionTime\n                actionDescription\n                user {\n                  fullName\n                  id\n                }\n                id\n              }\n            }\n          }\n          contract {\n            id\n            currency\n            symbol\n            name\n            industry\n            ibConId\n            instrumentType\n            exchange {\n              name\n              symbol\n              id\n            }\n          }\n          account {\n            id\n            name\n            clientaccount {\n              id\n              accountType\n            }\n          }\n          portfolioOrder {\n            id\n          }\n          executionSet {\n            edges {\n              node {\n                transaction {\n                  id\n                }\n                price\n                proceeds\n                executionDatetime\n                quantity\n                currency\n                id\n              }\n            }\n          }\n          proceedsToDate\n          proceedsToDateBase\n          brokerOrder {\n            id\n            twsOrderId\n            twsPermId\n            cashQuantity\n            quantityFilled\n            quantityLeft\n            stopPrice\n            trailStopRatio\n            trailStopOffset\n            lastSyncTime\n            status\n            orderRef\n            ackedClientOrderId\n            brokerSideOrderId\n            ibExchange {\n              id\n              symbol\n            }\n            algoParams {\n              algo\n              orderalgoparamstwap {\n                strategyType\n                startTime\n                endTime\n                allowPastEndTime\n                id\n              }\n              orderalgoparamsvwap {\n                id\n                maxVolumeRatio\n                startTime\n                endTime\n                allowPastEndTime\n                neverTakeLiquidity\n                speedup\n              }\n              id\n            }\n            brokerorderamendmentSet(orderBy: \"sequence\") {\n              edges {\n                node {\n                  id\n                  limitPrice\n                  previousLimitPrice\n                  quantity\n                  previousQuantity\n                  status\n                  blockingRevised\n                  createdAt\n                  updatedAt\n                }\n              }\n            }\n          }\n          orderPtr {\n            orderapprovalcontractSet {\n              edges {\n                node {\n                  id\n                  approval {\n                    id\n                    portfolioOrder {\n                      id\n                      status\n                    }\n                    createdAt\n                    updatedAt\n                    approvedAt\n                    notifiedAt\n                    remindedAt\n                    proposal {\n                      id\n                      type\n                    }\n                    rationaleUrl\n                    approvedBy {\n                      fullName\n                      id\n                    }\n                    status\n                    portfolio {\n                      id\n                      trackingVueName\n                      account {\n                        name\n                        id\n                      }\n                    }\n                    actionLogs {\n                      edges {\n                        node {\n                          id\n                          actionDescription\n                          actionId\n                          actionTime\n                          actionType\n                          user {\n                            id\n                            fullName\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n            id\n          }\n          tradeInvoice {\n            id\n            pdfUrl\n            pdf\n            state\n            createdAt\n            updatedAt\n            portfolioOrder {\n              id\n            }\n          }\n          transactions {\n            edges {\n              node {\n                id\n                commission\n                tax\n                transactionaccountchargeSet {\n                  edges {\n                    node {\n                      id\n                      amount\n                      currency\n                      feeType\n                      accountchargePtr {\n                        accountchargetenantportionSet {\n                          edges {\n                            node {\n                              id\n                              quantity\n                              tenant {\n                                name\n                                id\n                              }\n                            }\n                          }\n                        }\n                        id\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    exchanges {\n      edges {\n        node {\n          symbol\n          nextDaySession {\n            startTime\n            endTime\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7de916f7f650905bf0d8e98632ad2bf1';
module.exports = node;
